<aslib-title ></aslib-title>


<form novalidate [formGroup]='formConsultaRoyalties'>
  <div class="form-group row">
    <label for="dataReferenciaDistribuicao" class="col-md-3 text-right">Mês/Ano de Referência:<span style="color: red;">*</span></label>
    <div class="controls col-md-2">
      <input type="text" appMonthYear placeholder="MM/AAAA" [(ngModel)]="filtro.anoReferencia" required formControlName="dataReferenciaDistribuicao" class="form-control" />
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-4 offset-md-3">
      <button type="submit" class="btn btn-primary" (click)="filtrar(grid)" >
        <aslib-icon type="1" icon="fa fa-search"></aslib-icon>Filtrar</button>
    <button type="submit" class="btn btn-primary" (click)="limparConsulta()" >
        <aslib-icon type="1" icon="fa fa-refresh"></aslib-icon>Limpar </button>
    </div>
    
  </div>

</form>
  <div class="form-group row" >
    <div class="col-md-12 text-right">
      <button type="submit" class="btn btn-primary" (click)="irPraAdicionar()"  >
        <aslib-icon type="1" icon="fa fa-plus"></aslib-icon>Adicionar Valor a Distribuir
      </button>
    </div>
    </div>

<div class="form-group row mb-5" *ngIf="exibirGrid" >
  
  <aslib-grid #grid id="as-libgrid" class="col-md-12" [(dataset)]="dadosValoresDistribuir"  [pagination]="true">
    
    <aslib-grid-column   [property]="'DataReferenciaDistribuicaoFormatada'"  [header]="'Mês/Ano de Referência'"  [width]="100"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item" >
        <span>{{ item.DataReferenciaDistribuicaoFormatada }}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'ValorMensalDistribuicao'" [header]="'Valor dos Royalties a Distribuir'" [width]="100" [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.ValorMensalDistribuicao | currency:'BRL':'symbol':'1.2-2'}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'NomeUsuarioInclusao'" [header]="'Usuário Criação'" [width]="80" [sortable]="true"></aslib-grid-column>
    <aslib-grid-column   [property]="'DataInclusaoFormatada'"  [header]="'Data/Hora Criação'"  [width]="80"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item" >
        <span>{{ item.DataInclusaoFormatada }}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'NomeUsuarioAlteracao'" [header]="'Usuário Última Alteração'" [width]="80" [sortable]="true"></aslib-grid-column>
        <aslib-grid-column   [property]="'DataAlteracaoFormatada'"  [header]="'Data/Hora Última Alteração'"  [width]="80"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item" >
        <span>{{ item.DataAlteracaoFormatada}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="40" [sortable]="false" [resizable]="false"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <button type="button" class="btn btn-sm btn-primary" title="Editar"
          ascas-data="Editar item" (click)="editar(detalheVldistribuir,item)">
          <aslib-icon type="1" icon="fa fa-pencil"></aslib-icon>
        </button>
        <button type="button" class="btn btn-sm btn-primary" title="Excluir"
          ascas-data="Excluir registro" (click)="excluir(modalMensagem,item)">
          <aslib-icon type="1" icon="fa fa-trash"></aslib-icon>
        </button>
      </ng-template>
    </aslib-grid-column>
  </aslib-grid>
</div>
  <div class="form-group row"  *ngIf="exibirGrid">
        <div class="col-md-1">
      <button type="submit" class="btn btn-primary" (click)="gerarRelatorio()"  >
        <aslib-icon type="1" icon="fa fa-save"></aslib-icon>Excel
      </button>
    </div>
  </div>
<div class="card-block">  
  <div class="row">
    <div class="col-md-10">
    <ng-template #detalheVldistribuir>
      <sarf-detalhe-valor-mensal-distribuir [mesanoSelecionado]="itemSelecionado"  (onConfirm)="onConfirmPropagar($event)" (onClose)="onClose($event)"></sarf-detalhe-valor-mensal-distribuir>
    </ng-template>
    </div>
  </div>
<aslib-modal #modalMensagem></aslib-modal>
  </div>


// WEBPACK FOOTER //
// ./src/app/royalts/valor-mensal-distribuir/consulta-valor-mensal-distribuir.component.html